import DownloadIcon from "@/assets/images/icons2/icon--download.svg?component";

import { Button2 } from "../atoms/Button";
import type { ButtonProps } from "../atoms/Button";

export function DownloadButton({ children: _children, ...buttonProps }: ButtonProps) {
  return (
    <Button2 variant="blank" {...buttonProps}>
      <DownloadIcon />
    </Button2>
  );
}
